import { t } from 'i18next';
import { Typography } from '@mui/material';
import { useUserSegments } from '@hooks';
import { BoxContainer } from '@layouts';
import { SelectFetch } from '@molecules';

/**
 * SelectSegmentCard selector shows all segments
 */
const SelectSegmentCard = ({
  setSegment,
  segment,
  showSubSegments = false,
}: {
  segment: string;
  setSegment: (v: string) => void;
  showSubSegments?: boolean;
}) => {
  const segments = useUserSegments(showSubSegments);
  return (
    <BoxContainer>
      <Typography variant='h4'>{t('COMMON:SEGMENT')}</Typography>
      <SelectFetch
        onChange={(e) => {
          setSegment(e.target.value);
        }}
        getOptions={() => segments}
        value={segment}
        parseOption={(item) => ({ text: item.name, value: item.number })}
      />
    </BoxContainer>
  );
};
export default SelectSegmentCard;
